module.exports = __webpack_public_path__ + "img/during-round.217f42dc.png";